import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import * as moment from "moment";

export class PlanningServicesFiltersComponent implements IController {
  filters: any;
  template?: any;
  enableDates?: boolean;
  isHideStatusSelect?: boolean;
  onChangeFilters: Function;


  public isLocationSectionExpanded: boolean = false;
  public isTimeSectionExpanded: boolean = false;
  public isExecutionSectionExpanded: boolean = false;
  public isInformationSectionExpanded: boolean = false;

  public isPickupTimeWindowEnabled: boolean = false;
  public isDropoffTimeWindowEnabled: boolean = false;

  constructor(private moment) {
  }
  $onInit() {


    // Only if no time windows are set in filters, check template for defaults
    const hasExistingPickupTimeWindow =
      _.get(this.filters, 'pickupTimeFrom') != null &&
      _.get(this.filters, 'pickupTimeTo') != null;

    const hasExistingDropoffTimeWindow =
      _.get(this.filters, 'dropoffTimeFrom') != null &&
      _.get(this.filters, 'dropoffTimeTo') != null;

    // Initialize from template if available and no existing values
    if (!hasExistingPickupTimeWindow && this.template?.dispatchFilter) {
      const templatePickupFrom = _.get(this.template, 'dispatchFilter.pickupTimeFrom');
      const templatePickupTo = _.get(this.template, 'dispatchFilter.pickupTimeTo');

      if (templatePickupFrom != null && templatePickupTo != null) {
        this.filters.pickupTimeFrom = templatePickupFrom;
        this.filters.pickupTimeTo = templatePickupTo;
        this.isPickupTimeWindowEnabled = true;
      }
    } else {
      this.isPickupTimeWindowEnabled = hasExistingPickupTimeWindow;
    }

    if (!hasExistingDropoffTimeWindow && this.template?.dispatchFilter) {
      const templateDropoffFrom = _.get(this.template, 'dispatchFilter.dropoffTimeFrom');
      const templateDropoffTo = _.get(this.template, 'dispatchFilter.dropoffTimeTo');

      if (templateDropoffFrom != null && templateDropoffTo != null) {
        this.filters.dropoffTimeFrom = templateDropoffFrom;
        this.filters.dropoffTimeTo = templateDropoffTo;
        this.isDropoffTimeWindowEnabled = true;
      }
    } else {
      this.isDropoffTimeWindowEnabled = hasExistingDropoffTimeWindow;
    }
  }

  onDateChange(from, to) {
    this.filters.dueFrom = undefined;
    this.filters.dueTo = undefined;
    this.filters.createdAtFrom = undefined;
    this.filters.createdAtTo = undefined;

    this.filters.from = moment(from).valueOf();
    this.filters.to = moment(to).endOf('day').valueOf();

    if (this.filters.from >= this.filters.to) {
      this.filters.to = moment(this.filters.from).endOf('day').toDate();
    }

    if (this.filters.filterByCreatedAt) {
      this.filters.createdAtFrom = moment(from).valueOf()
      this.filters.createdAtTo = moment(to).valueOf()
    } else {
      this.filters.dueFrom = moment(from).valueOf()
      this.filters.dueTo = moment(to).valueOf()
    }
    this.onChangeFilters({filters: this.filters});
  }

  onChangeServiceAreasIds(serviceAreaIds) {
    _.set(this.filters, 'serviceAreaIds', serviceAreaIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeDepotIds(depotIds) {
    _.set(this.filters, 'depotIds', depotIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeStatuses(statuses) {
    _.set(this.filters, 'statuses', statuses);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeAccountIds(accountIds) {
    _.set(this.filters, 'accountIds', accountIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeServiceTypes(serviceTypes) {
    _.set(this.filters, 'serviceTypes', serviceTypes);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeTagNames(tagNames, isExcludeMode) {
    if (isExcludeMode) {
      _.set(this.filters, 'excludedTags', tagNames);
      _.unset(this.filters, 'tags');
    } else {
      _.set(this.filters, 'tags', tagNames);
      _.unset(this.filters, 'excludedTags');
    }
    this.onChangeFilters({filters: this.filters});
  }

  onChangeProgramTypes(programTypes) {
    _.set(this.filters, 'programTypes', programTypes);
    this.onChangeFilters({filters: this.filters});
  }

  onChangePackageTypes(packageTypes) {
    _.set(this.filters, 'packageTypes', packageTypes);
    this.onChangeFilters({filters: this.filters});
  }

  onTogglePickupTimeWindow() {
    if (this.isPickupTimeWindowEnabled) {
      // Initialize with default times: 00:00 - 23:59
      this.filters.pickupTimeFrom = this.moment().startOf('day').set({'second': 0, 'millisecond': 0}).valueOf();
      this.filters.pickupTimeTo = this.moment().startOf('day').set({'hour': 23, 'minute': 59, 'second': 0, 'millisecond': 0}).valueOf();
    } else {
      // Clear the filter values when disabled
      _.unset(this.filters, 'pickupTimeFrom');
      _.unset(this.filters, 'pickupTimeTo');
    }
    this.onChangeFilters({filters: this.filters});
  }

  onToggleDropoffTimeWindow() {
    if (this.isDropoffTimeWindowEnabled) {
      // Initialize with default times: 00:00 - 23:59
      this.filters.dropoffTimeFrom = this.moment().startOf('day').set({'second': 0, 'millisecond': 0}).valueOf();
      this.filters.dropoffTimeTo = this.moment().startOf('day').set({'hour': 23, 'minute': 59, 'second': 0, 'millisecond': 0}).valueOf();
    } else {
      // Clear the filter values when disabled
      _.unset(this.filters, 'dropoffTimeFrom');
      _.unset(this.filters, 'dropoffTimeTo');
    }
    this.onChangeFilters({filters: this.filters});
  }

  onPickupTimeFromChange(time) {
    // Normalize to remove seconds and milliseconds
    _.set(this.filters, 'pickupTimeFrom', this.moment(time).set({'second': 0, 'millisecond': 0}).valueOf());
    this.onChangeFilters({filters: this.filters});
  }

  onPickupTimeToChange(time) {
    // Normalize to remove seconds and milliseconds
    _.set(this.filters, 'pickupTimeTo', this.moment(time).set({'second': 0, 'millisecond': 0}).valueOf());
    this.onChangeFilters({filters: this.filters});
  }

  onDropoffTimeFromChange(time) {
    // Normalize to remove seconds and milliseconds
    _.set(this.filters, 'dropoffTimeFrom', this.moment(time).set({'second': 0, 'millisecond': 0}).valueOf());
    this.onChangeFilters({filters: this.filters});
  }

  onDropoffTimeToChange(time) {
    // Normalize to remove seconds and milliseconds
    _.set(this.filters, 'dropoffTimeTo', this.moment(time).set({'second': 0, 'millisecond': 0}).valueOf());
    this.onChangeFilters({filters: this.filters});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningServicesFilters', {
    bindings: {
      filters: '<',
      template: '<?',
      enableDates: '<?',
      isHideStatusSelect: '<?',
      onChangeFilters: '&'
    },
    template: require('./planning-services-filters.html').default,
    controller: PlanningServicesFiltersComponent
  });

